import React from "react";
import './reviews.css';

const Reviews = () => {
    return (
        <section className="review">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                        <div className="heading">
                            <h3>People Say<br/> About Techvanto</h3>
                        </div>
                        <div className="text">
                            <p>One-stop solution for any eLearning center, online courses. People love Techvanto because they can
                                create their sites with ease here.
                            </p>
                        </div>
                        <div className="view-all-btn">
                            <button type="button">View all</button>                            
                        </div>
                    </div>
                    <div className="col-lg-9 col-md-12 col-sm-12 col-12">
                        <div className="wrapper">
                            <div className="carousel owl-carousel">
                                <div className="revw">
                                    <h4>Great Quality!</h4>
                                    <div className="revw-text">
                                        I wanted to place a review since their support helped me within a day or so, which is nice! 
                                        Thanks and 5 Star!
                                    </div>
                                    <div className="info">
                                        <div className="img">
                                            <img src="images/review_img_1.jpg" />
                                        </div>
                                        <div className="detail">
                                            <h2>Oliver Beddows</h2>
                                            <p>Designer, Manchester</p>
                                        </div>
                                    </div>
                                    <div className="quote">
                                        <i className="fas fa-quote-right"></i>
                                    </div>
                                </div>
                                <div className="revw">
                                    <h4>Great Quality!</h4>
                                    <div className="revw-text">
                                        I wanted to place a review since their support helped me within a day or so, which is nice! 
                                        Thanks and 5 Star!
                                    </div>
                                    <div className="info">
                                        <div className="img">
                                            <img src="images/review_img_1.jpg" />
                                        </div>
                                        <div className="detail">
                                            <h2>Oliver Beddows</h2>
                                            <p>Designer, Manchester</p>
                                        </div>
                                    </div>
                                    <div className="quote">
                                        <i className="fas fa-quote-right"></i>
                                    </div>
                                </div>
                                <div className="revw">
                                    <h4>Great Quality!</h4>
                                    <div className="revw-text">
                                        I wanted to place a review since their support helped me within a day or so, which is nice! 
                                        Thanks and 5 Star!
                                    </div>
                                    <div className="info">
                                        <div className="img">
                                            <img src="images/review_img_1.jpg" />
                                        </div>
                                        <div className="detail">
                                            <h2>Oliver Beddows</h2>
                                            <p>Designer, Manchester</p>
                                        </div>
                                    </div>
                                    <div className="quote">
                                        <i className="fas fa-quote-right"></i>
                                    </div>
                                </div>
                                <div className="revw">
                                    <h4>Great Quality!</h4>
                                    <div className="revw-text">
                                        I wanted to place a review since their support helped me within a day or so, which is nice! 
                                        Thanks and 5 Star!
                                    </div>
                                    <div className="info">
                                        <div className="img">
                                            <img src="images/review_img_1.jpg" />
                                        </div>
                                        <div className="detail">
                                            <h2>Oliver Beddows</h2>
                                            <p>Designer, Manchester</p>
                                        </div>
                                    </div>
                                    <div className="quote">
                                        <i className="fas fa-quote-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
    )
}
export default Reviews;